module.exports = __webpack_public_path__ + "static/media/savedEventsBack.5863de27.svg";